import React from 'react';
import { Box, Typography } from '@mui/material';
import { useGetCategoriesByBrowseNodeId } from '@hooks/useBrowseNodeCategories';
import ShowDealsFromBrowseNodeMapping from '@components/ShowDealsFromBrowseNodeMapping';
import DeleteBrowseNodeMapping from '@components/DeleteBrowseNodeMapping';

const DealListMappings = React.memo(
  ({ dealListId }: { dealListId: number }) => {
    const { data: categories, isLoading } =
      useGetCategoriesByBrowseNodeId(dealListId);

    if (isLoading) {
      return <Box>Loading...</Box>;
    }

    return (
      <Box>
        {(categories || []).map((category) => (
          <Box key={category.categoryId} marginBottom="8px">
            <Box display="flex" justifyContent="space-between" margin="8px 0">
              <Typography variant="overline">
                Browse Node Mapping <strong>{category.contextFreeName}</strong>
              </Typography>
              <Box>
                <Box marginRight="8px" display="inline">
                  <DeleteBrowseNodeMapping
                    contextFreeName={category.contextFreeName}
                    categoryId={category.categoryId}
                    dealListId={dealListId}
                    forever={false}
                  />
                </Box>

                <Box display="inline">
                  <DeleteBrowseNodeMapping
                    contextFreeName={category.contextFreeName}
                    categoryId={category.categoryId}
                    dealListId={dealListId}
                    forever
                  />
                </Box>
              </Box>
            </Box>
            <ShowDealsFromBrowseNodeMapping categoryId={category.categoryId} />
          </Box>
        ))}
      </Box>
    );
  }
);

export default DealListMappings;
